import OverlayTrigger from "react-bootstrap/esm/OverlayTrigger";
import Tooltip from "react-bootstrap/esm/Tooltip";

/**
 * Help icon component is an icon that, when clicked, opens a new tab.
 * @param props 
 * @returns 
 */
export default function HelpIcon(props: {text: string, url: string}) {
    return (<>
        <div style={{display: "inline-block"}}>

        <OverlayTrigger
          key="top"
          placement="top"
          overlay={
            <Tooltip>
              {props.text}
            </Tooltip>
          }
        > 
            { props.url != "" ?
            <a target="popup" href={props.url} onClick={() => window.open(props.url,"popup","width=600,height=600")}>
                <img src="/assets/icons/help.svg" />
            </a>
            :
            <a target="popup">
                <img src="/assets/icons/help.svg" />
            </a>
            }
            </OverlayTrigger>
        </div> 
    </>)
}